export default "__VITE_ASSET__85f24a8b__"